import { Drawer, Form, Input, Button } from "antd";
import { useCallback, useMemo } from "react";
import type { MerchantCabinetUpdateType } from "@src/types";
import { useMerchantCabinetUpdate } from "@src/queries";

type Props = {
    open: boolean;
    onClose: () => void;
    cabinetId: string;
    username: string;
};

export default function MerchantCabinetUpdateDrawer({ open, onClose, cabinetId, username }: Props) {
    const [form] = Form.useForm<MerchantCabinetUpdateType>();
    const { mutateAsync, isPending } = useMerchantCabinetUpdate(cabinetId);

    const initialValues = useMemo<Partial<MerchantCabinetUpdateType>>(() => ({ password: "" }), []);

    const handleFinish = useCallback(
        async (values: MerchantCabinetUpdateType) => {
            await mutateAsync(values, {
                onSuccess: () => {
                    form.resetFields();
                    onClose();
                },
            });
        },
        [mutateAsync, form, onClose],
    );

    const handleClose = useCallback(() => {
        if (!isPending) {
            form.resetFields();
            onClose();
        }
    }, [isPending, form, onClose]);

    return (
        <Drawer
            title="Обновить кабинет"
            open={open}
            onClose={handleClose}
            destroyOnHidden
            maskClosable={!isPending}
            extra={
                <Button type="primary" loading={isPending} onClick={() => form.submit()}>
                    Сохранить
                </Button>
            }
        >
            <Form<MerchantCabinetUpdateType>
                form={form}
                layout="vertical"
                onFinish={handleFinish}
                initialValues={initialValues}
                requiredMark="optional"
            >
                <Form.Item label="Логин">
                    <Input value={username} disabled />
                </Form.Item>

                <Form.Item
                    label="Новый пароль"
                    name="password"
                    rules={[
                        { required: true, message: "Введите новый пароль" },
                        { min: 6, message: "Минимум 6 символа" },
                    ]}
                >
                    <Input.Password placeholder="Введите новый пароль" autoFocus />
                </Form.Item>
            </Form>
        </Drawer>
    );
}
